import type { Option } from "@/nzds/inputs/inputs.types"

export const buildStringSelectOptions = (
  values: string[],
  currentValue?: string | null,
  leadingOption?: Option
): Option[] => {
  const options: Option[] = values.map((value) => ({ label: value, value }))
  const trimmedCurrent = currentValue?.trim()

  if (trimmedCurrent) {
    // A stored value that differs from an option only by case is that option,
    // not a second one. Records predate the list and disagree with it on
    // casing (kWh against kwh, MMBTU against mmbtu), so an exact-match check
    // renders the same unit twice. Adopt the record's spelling for the option
    // it matches: the select resolves to one entry, and saving the form leaves
    // the stored spelling alone.
    const matchIndex = options.findIndex(
      (option) =>
        typeof option.value === "string" &&
        option.value.toLowerCase() === trimmedCurrent.toLowerCase()
    )

    if (matchIndex === -1) {
      options.push({ label: trimmedCurrent, value: trimmedCurrent })
    } else {
      options[matchIndex] = { label: trimmedCurrent, value: trimmedCurrent }
    }
  }

  return leadingOption ? [leadingOption, ...options] : options
}
